// used for leave periods

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const tab_anchor = window.location.hash.slice(1) || 'pending'
    // set initial tab
    this.switchTab(null, tab_anchor)

    // // Update URL if no hash present
    // if (!window.location.hash) {
    //   history.replaceState(null, null, `#${tab}`)
    // }
  }

  switchTab(event = null, tab_anchor = null) {
    const state = tab_anchor ? tab_anchor : event.params.state
    const tabEl = event ? event.srcElement : document.querySelector(`.nav-link[href="#${state}"]`)

    const tab = new bootstrap.Tab(tabEl)
    tab.show()

    const frame = document.getElementById('tab-content')
    frame.src = `/admin/leave_periods/list?state=${state}`
    // Update URL without triggering page reload
    history.replaceState(null, null, `#${state}`)
  }
}
